// extracted by mini-css-extract-plugin
module.exports = {"solutions":"Solutions_solutions__3hkD0","heading":"Solutions_heading__2eO8V","text":"Solutions_text__Z7fEJ","grid":"Solutions_grid__3sh69"};